// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"28d4307c","313":"96ea1094","322":"697e73cb","549":"4b0c9e40"}[chunkId] + ".chunk.js";
};